module.exports = __webpack_public_path__ + "static/img/home.7b7d06dc.jpg";